import TranslationTool from "./TranslationTool";
import "../tabs.css";

type TranslateTabProps = {
  searchText: string;
};

export default function TranslateTab({ searchText }: TranslateTabProps) {
  return (
    <div className="translate-items">
      <TranslationTool searchText={searchText} />
    </div>
  );
}
